import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  List,
  ListItem,
  ListItemText,
  Typography,
  Box,
  Chip
} from '@mui/material';
import { formatCurrency, formatDate } from '../utils/formatters';

interface TransactionMatcherProps {
  open: boolean;
  transaction: any;
  bankTransactions: any[];
  bookTransactions: any[];
  onMatch: (bankTxn: any, bookTxn: any) => void;
  onClose: () => void;
}

export const TransactionMatcher: React.FC<TransactionMatcherProps> = ({
  open,
  transaction,
  bankTransactions,
  bookTransactions,
  onMatch,
  onClose
}) => {
  const [selectedTransaction, setSelectedTransaction] = useState<any>(null);

  const handleMatch = () => {
    if (selectedTransaction) {
      onMatch(transaction, selectedTransaction);
      onClose();
    }
  };

  const getConfidenceColor = (confidence: number) => {
    if (confidence >= 0.8) return 'success';
    if (confidence >= 0.5) return 'warning';
    return 'error';
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>Match Transaction</DialogTitle>
      <DialogContent>
        <Box sx={{ mb: 3 }}>
          <Typography variant="h6">Source Transaction</Typography>
          <Box sx={{ p: 2, bgcolor: 'background.paper', borderRadius: 1 }}>
            <Typography>Date: {formatDate(transaction?.date)}</Typography>
            <Typography>Amount: {formatCurrency(transaction?.amount)}</Typography>
            <Typography>Description: {transaction?.description}</Typography>
          </Box>
        </Box>

        <Typography variant="h6">Potential Matches</Typography>
        <List>
          {bookTransactions.map((txn) => (
            <ListItem
              key={txn.id}
              button
              selected={selectedTransaction?.id === txn.id}
              onClick={() => setSelectedTransaction(txn)}
              sx={{ mb: 1, border: 1, borderColor: 'divider', borderRadius: 1 }}
            >
              <ListItemText
                primary={
                  <Box display="flex" justifyContent="space-between" alignItems="center">
                    <Typography>{txn.description}</Typography>
                    <Chip
                      label={`${(txn.matchConfidence * 100).toFixed(0)}% Match`}
                      color={getConfidenceColor(txn.matchConfidence)}
                      size="small"
                    />
                  </Box>
                }
                secondary={
                  <>
                    <Typography component="span" variant="body2">
                      Date: {formatDate(txn.date)}
                    </Typography>
                    <br />
                    <Typography component="span" variant="body2">
                      Amount: {formatCurrency(txn.amount)}
                    </Typography>
                  </>
                }
              />
            </ListItem>
          ))}
        </List>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          onClick={handleMatch}
          disabled={!selectedTransaction}
          variant="contained"
          color="primary"
        >
          Confirm Match
        </Button>
      </DialogActions>
    </Dialog>
  );
}; 